export const removeUnwantedKeys = (obj, keysToRemove) => {
    keysToRemove.forEach((key) => {
      if (obj.hasOwnProperty(key)) {
        delete obj[key];
      }
    });
  }